// eslint-disable-next-line no-restricted-imports
import {
  LockedPosition as ApiLockedPosition,
  PositionResponse as ApiPositionResponse,
  Configuration,
  DefaultApiCreateOpenPositionNoteRequest,
  DefaultApiGetOpenPositionNotesRequest,
  DefaultApiModifyOpenPositionNoteRequest,
  DefaultApi as PositionApi,
} from '@eih-netbroker/api-position';
import { AxiosInstance, AxiosResponse } from 'axios';
import { IConfigAPI } from '../config/config';
import { ResourceHeadersOfMultiAccountRequest, ResourceHeadersWithToken } from '../services/useResource';
import { CollateralSummaryAmount, CollateralSummaryItem } from '../types/portfolio/collateralSummaryItem';
import { BaseResource } from './base.resource';

export type ColletarDetailsResponse = {
  collateralSummaryItems: Array<CollateralSummaryItem>;
  collateralSummaryAmountsByClientId: Array<CollateralSummaryAmount>;
};

export type PositionNotesRequest = Omit<DefaultApiGetOpenPositionNotesRequest, keyof ResourceHeadersWithToken>;
export type PositionNotesCreate = Omit<DefaultApiCreateOpenPositionNoteRequest, keyof ResourceHeadersWithToken>;
export type PositionNotesModify = Omit<DefaultApiModifyOpenPositionNoteRequest, keyof ResourceHeadersWithToken>;
export type PositionLockedPosition = ApiLockedPosition;
export type PositionPortfolioResponse = ApiPositionResponse;

export class PositionResource extends BaseResource {
  // Name has to be overridden, since the build job renames it to 'r' and
  // every resource class will have the same name
  // @ts-ignore
  static readonly name = 'PositionResource';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private positionApi: PositionApi;

  constructor(axiosInstance: AxiosInstance, basePath: string, configApi: IConfigAPI) {
    super(axiosInstance, `${basePath}${configApi.usUrl.positions}`, configApi);
    this.positionApi = new PositionApi(
      new Configuration({
        basePath: `${basePath}${configApi.usUrl.positions}`,
      }),
      `${basePath}${configApi.usUrl.positions}`,
      axiosInstance,
    );
  }

  async getPortfolio(headers: ResourceHeadersWithToken): Promise<AxiosResponse<PositionPortfolioResponse>> {
    return this.positionApi.getPortfolio({ ...headers });
  }

  async getCollateralDetails(headers: ResourceHeadersOfMultiAccountRequest) {
    // TODO: remove cast when yaml is fixed
    return this.positionApi.getCollateralDetails({
      ...headers,
      accountNumberList: headers.accountId,
    }) as unknown as Promise<AxiosResponse<ColletarDetailsResponse>>;
  }

  getVersion() {
    return this.positionApi.getVersion();
  }

  async getOpenPositionNotes(request: PositionNotesRequest, headers: ResourceHeadersOfMultiAccountRequest) {
    return this.positionApi.getOpenPositionNotes({ ...request, ...headers });
  }

  async createOpenPositionNotes(request: PositionNotesCreate, headers: ResourceHeadersWithToken) {
    return this.positionApi.createOpenPositionNote({ ...request, ...headers });
  }

  async modifyOpenPositionNotes(request: PositionNotesModify, headers: ResourceHeadersWithToken) {
    return this.positionApi.modifyOpenPositionNote({ ...request, ...headers });
  }
}
